import { render, staticRenderFns } from "./CompanyIdDocuments.vue?vue&type=template&id=5af58bfc&scoped=true"
import script from "./CompanyIdDocuments.vue?vue&type=script&lang=js"
export * from "./CompanyIdDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af58bfc",
  null
  
)

export default component.exports